import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const PROFILE_LIST_FETCH = 'unifi.PROFILE_LIST_FETCH'
export const PROFILE_CREATE = 'unifi.PROFILE_CREATE'

// ------------------------------------
// Action Creators
// ------------------------------------
export const listAllProfiles = createWsAction({
    type: PROFILE_LIST_FETCH,
    messageType: 'core.camera.list-all-cameras',
    selectorKey: 'profileList',
    fields: ['clientId']
})

export const createProfile = createWsAction({
    type: PROFILE_CREATE,
    messageType: 'core.camera.add-camera',
    selectorKey: 'profileDetail',
    fields: ['clientId', 'siteId', 'zoneId', 'agentId', 'cameraSn', 'endpoint'],
});

export default null


// WEBPACK FOOTER //
// ./src/redux/modules/model/profile.js